import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { FundamentalMetrics } from '../../models/FundamentalMetrics';
import { fetchCompanyFundamentals } from '../../services/riskProducts.service';
import { queryKeys } from '../queryKeyFactory';
import { mapFundamentalMetricsDtoToFundamentalMetrics } from './utils/fundamental.mappers';

export default (companyId: string | null): UseQueryResult<FundamentalMetrics, Error> => {
  return useQuery<FundamentalMetrics, Error>(
    queryKeys.fetchFundamentals(companyId!),
    async () => {
      const metricsDto = await fetchCompanyFundamentals(companyId!);
      return mapFundamentalMetricsDtoToFundamentalMetrics(metricsDto);
    },
    {
      retry: false,
    }
  );
};
